import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=4a708d56&scoped=true&"
import script from "./help.js?vue&type=script&lang=js&"
export * from "./help.js?vue&type=script&lang=js&"
import style0 from "./help.css?vue&type=style&index=0&id=4a708d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a708d56",
  null
  
)

export default component.exports